<template>
  <div class="container">
    <div class="containerBg">
      <div class="title">
        <router-link :to="{path:'/'}"><img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/sy.png" class="return" /></router-link>
        <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/fh.png" class="return" @click="clickReturn" />
        <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/zhibo/gx.png" class="guang1" />
        <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/zhibo/gx.png" class="guang2" /> 
      </div>
      <div class="content">
        <!-- 左侧 -->
        <!-- <div class="left animate__animated animate__slideInLeft">
          <div class="leftNavBg" :class="curNav==index ? 'leftNavBgCur':''" v-for="(item,index) in leftNav" :key="index"><router-link :to="{path:item.path}"><div class="leftNavItem">{{item.name}}</div></router-link></div>
        </div> -->
         <!--中间  -->
        <div class="center">

          <!-- <div class="mapIcon3">
            <img src="https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/mapIcon3.gif" />
          </div> -->
        </div>
        
        <!-- 右侧 -->
        <div class="right animate__animated animate__slideInRight">
          <div class="rightBox rightBox1">
            <div class="rightTitle">
              <router-link :to="{path:'/jiagong'}"><div class="titleCon">车间基本管理<span></span></div></router-link>
              <div class="subTit">
                <div class="subTitItem" :class="{subTitItemCur:rightData1TitCur==index}" v-for="(item,index) in rightData1Tit" :key="index" @click="rightClick(index)">
                  {{item.name}}
                  
                </div>
                <div class="subTitItemCurguang"></div>
              </div>
              <!-- <div class="music"><span></span> <span></span> <span></span></div> -->
            </div>
            <div class="rightContent1">
              <div class="rightContent1List" v-if="showDiv">
                  <div class="rightContent1Item animate__animated animate__slideInRight" v-for="(item,index) in rightData1[rightData1TitCur]" :key="index">
                  <div class="leftIcon"><img :src="item.icon" /></div>
                  <div class="rightContent1ItemRight"><span>{{item.value}}{{item.unit}}</span><span>{{item.name}}</span></div>
                </div>
              </div>
              
            </div>
          </div>
          <div class="rightBox rightBox2">
            <router-link :to="{path:'/kshyqjk'}"><div class="rightTitle"><div class="titleCon">运行状态<span></span></div><div class="music"><span></span> <span></span> <span></span></div></div></router-link>
            <div class="rightContent2"><RightBar/> </div>
          </div>
          <div class="rightBox rightBox3">
            <div class="rightTitle"><div class="titleCon">车间流动<span></span></div><div class="music"><span></span> <span></span> <span></span></div></div>
            <div class="rightContent3">
              <div class="rightContent3Left"> <RightRadar /> </div>
              <div class="rightContent3Right">
                <div class="rightContent3RightItem" v-for="(item,index) in rightData3" :key="index">
                  <div class="rightContent3RightItemName">{{item.name}}</div>
                  <div class="rightContent3RightItemValue">{{item.value}}%</div>
                </div>
              </div>
              </div>
          </div>
        </div>
      </div>
    </div>
      
  </div>
   <footer1 />
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from 'three';
import { useRouter } from 'vue-router'
import { inject } from 'vue';
 


import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
} from "vue";
// import waterimg from "@/assets/img/xaiofei/fk.png"

import RightBar from "../components/Chejian/RightBar"
import RightRadar from "../components/Chejian/RightRadar"
import footer1 from "../components/footer.vue";

export default {
  name: "Home",
  setup() {
    const { proxy } = getCurrentInstance();
    // const timer = ref(null);
    const router = useRouter();
    const state = reactive({
      currentTime: "",
      leftNav:[{name:"加工",path:"/jiagong"},{name:"车间",path:"/chejian"},{name:"监控",path:"/kshyqjk"}],
      curNav:1,
      rightData1:[
        {title:"监控情况",name:"异常占比",value:"0.03%",icon:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/tc.png",animateShow:false},
        {title:"停车情况",name:"停车占比",value:"73.2%",icon:"https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/jk.png",animateShow:false}
      ],
      animateShow:false,
      rightData1Tit:[{name:"A区"},{name:"B区"},{name:"C区"},{name:"D区"}],
      rightData1TitCur:0,
      rightData1:[[
          {name:"PM2.5",value:"20",unit:"μg/m3",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/pm.png'},
        {name:"温度",value:"23",unit:"℃",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/wd.png'},
        {name:"空气质量",value:"良好",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/kq.png'},
        {name:"湿度",value:"70%",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/sd.png'}
        ],[
          {name:"PM2.5",value:"90",unit:"μg/m3",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/pm.png'},
        {name:"温度",value:"30",unit:"℃",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/wd.png'},
        {name:"空气质量",value:"良好",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/kq.png'},
        {name:"湿度",value:"20%",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/sd.png'}
        ],[
          {name:"PM2.5",value:"26",unit:"μg/m3",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/pm.png'},
            {name:"温度",value:"16",unit:"℃",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/wd.png'},
            {name:"空气质量",value:"良好",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/kq.png'},
            {name:"湿度",value:"36%",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/sd.png'}
        ],[
          {name:"PM2.5",value:"10",unit:"μg/m3",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/pm.png'},
            {name:"温度",value:"28",unit:"℃",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/wd.png'},
            {name:"空气质量",value:"良好",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/kq.png'},
            {name:"湿度",value:"75%",unit:"",icon:'https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/sd.png'}
        ]],
      showDiv:true,
      rightData3:[
        {name:"数据一",value:18},
        {name:"数据二",value:15},
        {name:"数据三",value:14},
        {name:"数据四",value:10},
        {name:"数据五",value:16}
      ]
    });
    onMounted(() => {
        // clearInterval(timer.value);
        // timer.value = setInterval(() => {
        //   state.currentTime = proxy.$utils.getCurrentTime();
        // }, 1000);
        // console.log(state.currentTime)
    })
    onUnmounted(() => {
      // 清理资源
      
    });
    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    })
    // 右侧切换

    function rightClick(index){
      this.showDiv = false; // 点击后先隐藏div
      this.rightData1TitCur = index
      setTimeout(() => {
        this.showDiv = true; // 200ms后再重新显示div（模拟刷新）
      }, 200);
   
    }
    // 返回上一页
    function clickReturn(){
        router.go(-1);
    }
    // 鼠标经过
    function mouseenter(index){
      // let rightData1 = 
      state.rightData1[index].animateShow = true
    }
    // 鼠标离开
    function mouseleave(index){
      // let rightData1 = 
      state.rightData1[index].animateShow = false
    }
    return {
      ...toRefs(state),
      close,
      mouseenter,
      mouseleave,
      clickReturn,
      rightClick
    };
  },
  components: {
      RightBar,
      RightRadar,
      footer1
  },
};
</script>
<style lang="less" scoped>
body {
  background-size: cover;
  line-height: 1.15;
}
@font-face {
  font-family: electronicFont;
  src: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/font/DS-DIGIT.TTF");
}
a{
  color: #fff;
}
.container{
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/bg2.jpg") no-repeat top center;
  background-size: 100% 100%;
  overflow: hidden;
  .containerBg{
    width: 100%;
    height: 100%;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/fc.png") no-repeat top center;
    background-size: 100% 100%;
    color: #fff;
    position: relative;
  }
  .title{
    position: relative;
    width: 100%;
    height: 95px;
    background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/bt.png") no-repeat top center;
    background-size: 100% 100%!important;
    color: #fff;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .return{
      width: 68px;
      height: 23px;
      cursor: pointer;
      margin-right: 50px;
      margin-top: 16px;
      position: relative;
      z-index: 999;
    }
    .return:first-child{
      margin-left: 50px;
    }
    .guang1{
      position: absolute;
      top: -34px;
      left: 0;
      animation: titleGuang1 2s linear infinite;
      z-index: 0;
    }
    .guang2{
      position: absolute;
      top: -34px;
      right: 0;
      animation: titleGuang2 2s linear infinite;
    }
    @keyframes titleGuang1{
      0%{
        left: 0;
      }
      100%{
        left: 15%;
      }
    }
    @keyframes titleGuang2{
      0%{
        right: 0;
      }
      100%{
        right: 15%;
      }
    }
       
  }
  
  
  .content{
    width: 100%;
    height: calc(100% - 85px);
    display: flex;
    .left{
      // width: 127px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      // padding-left: 50px;
      .leftNavBg{
        width: 127px;
        height: 39px;
        margin: 50px 0;
        cursor: pointer;
        .leftNavItem{
          width: 100px;
          height: 39px;
          background: linear-gradient(to right, rgba(0,169,134,1) , rgba(0,169,134,0), rgba(0,169,134,1));
          box-shadow: 3px 0px 7px 0px #000000;
          border-radius: 18px 18px 18px 18px;
          line-height: 39px;
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          font-style: italic;
          color: #fff;
          transition: all 0.5s ease-out;
          animation: daxiao 1s linear infinite;
        }
        a{
          text-decoration:none;
        }
      }
      .leftNavBg:hover,.leftNavBgCur{
        background: linear-gradient(to right, rgba(97,238,166,1) , rgba(97,238,166,0));
        .leftNavItem{
          background: linear-gradient(to right, rgba(97,238,166,1) , rgba(97,238,166,0), rgba(97,238,166,1));
          margin-left:35px;
        }
      }  
    }
    .center{
      flex: 1;
      margin: 0 20px;
      position: relative;
      .centerBg1{
        position: absolute;
        right: 4%;
        top: 37%;
        background: url('https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/jx.png');
        width: 347px;
        height: 173px;
      }
      .mapIcon1{
        position: absolute;
        top:15%;
        left: 20%;
        img{
          width: 50px;
        }
      }
      .mapIcon2{
        position: absolute;
        top:33%;
        left: 50%;
        img{
          width: 50px;
        }
      }
      .centerInfo{
          position: absolute;
          top: 100%;
          left: 50%;
          width: 389px;
          height: 208px;
          margin-left: -195px;
          background: rgba(0,0,0,.5);
          border-radius: 10px 10px 10px 10px;
          animation-delay: 1s;
          padding: 25px;
          box-sizing: border-box;
          h3{
            font-size: 14px;
            font-weight: bold;
            font-style: italic;
            text-align: left;
          }
          .jkXq{
            padding: 5px 0 10px;
            .jkItemA{
              border-bottom: 1px solid #A9A9A9;
              display: flex;
              flex-wrap: wrap;
              padding: 8px 0;
              .jkItemB{
                width: 50%;
                display: flex;
                font-size: 14px;
                line-height: 30px;
                span{
                  display: block;
                }
                span:nth-child(1){
                  color: #A8A8A8;
                }
              }
            }
            .jkItemA:nth-child(2){
                border-bottom: 0;
               .jkItemB:nth-child(3){
                width: 100%;
               } 
              }

          }
        }
    }
    .right{
      width: 697px;
      margin-top: 20px;
      margin-right: 30px;
      display: flex;
      flex-direction: column;
      .rightBox{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-bottom: 15px;
        .rightTitle{
          width: 100%;
          height: 40px;
          background: #00140E;
          position: relative;
          .titleCon{
            position: absolute;
            left: -15px;
            top: 0;
            background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/btk.png") no-repeat top center;
            width: 216px;
            height: 64px;
            line-height: 60px;
            font-size: 18px;
            font-weight: bold;
            font-style: italic;
            position: relative;
            
            span{
               position: absolute;
               width: 50px;
                height: 8px;
                border-radius: 50%;
                opacity: .7;
                background-color: #003727;
                animation: scale 2s infinite cubic-bezier(0,0,.02,1.02);
                animation-delay: 200ms;
                top: 26px;
                left: 90px;
            }
            //  span:before {
            //     content: '';
            //     display:block;
            //     width: 116px;
            //     height: 24px;
            //     border-radius: 50%;
            //     opacity: .7;
            //     background-color: #FFFF00;
            //     animation: scale 2s infinite cubic-bezier(0,0,.49,1.02);
            //     animation-delay: 200ms;
            //     }
          }
          .subTit{
            position: absolute;
            right: 0;
            top: 0;
            display: flex;
            height: 100%;
            display: flex;
            align-items: center;
            overflow: hidden;
            .subTitItem{
              width: 84px;
              height: 41px;
              line-height: 41px;
              color: rgba(255,255,255,.8);
              font-size: 16px;
              cursor: pointer;
              position: relative;
              z-index: 999;
            }
            .subTitItemCur,.subTitItem:hover{
              width: 104px;
              background:  url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/jiagong/titCur.png") no-repeat top center;
              transition: all 0.5s ease-out;
              animation: daxiao1 1s linear infinite;
            }
            .subTitItemCurguang{
              position: absolute;
              width: 60%;
              height: 41px;
              top: 0;
              left: 0;
              background: linear-gradient(135deg,
                    rgba(255,255,255,.0),
                    rgba(255,255,255,.0) 25%,
                    rgba(255,255,255,.0) 50%,
                    rgba(255,255,255,.0) 55%,
                    rgba(255,255,255,.05) 60%,
                    rgba(255,255,255,0) 80%,
                    rgba(255,255,255,0.05) 95%,
                    rgba(255,255,255,0));
              animation: rightDaxiao2 1s linear infinite;
            }
            
          }
        }
      }
      .rightBox1{
        height: 200px;
        .rightContent1{
          width: 100%;
          flex: 1;
          padding: 0 50px;
          box-sizing: border-box;
          background: rgba(0,0,0,0.5);
          border: 1px solid #002D20;
          border-top: 0;
          .rightContent1List{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .rightContent1Item{
              display: flex;
              margin-right: 50px;
              cursor: pointer;
              .leftIcon{
                width: 40px;
                height: 40px;
                border-radius: 50%;
                position: relative;
                animation: rightDaxiao 2s linear infinite;
                img{
                  position: absolute;
                  width: 26px;
                  height: 26px;
                  top: 7px;
                  left: 7px;
                  animation: rightDaxiao1 2s linear infinite;
                }
              }
              .rightContent1ItemRight{
                display: flex;
                flex-direction: column;
                margin-left: 10px;
                font-size: 14px;
                span{
                  display: block;
                  text-align: left;
                  margin: 2px 0;
                }
                span:first-child{
                  color: #00AD7E;
                  font-size: 16px;
                }
              }
            }
          }

        }
      }
      .rightBox2{
        flex: 1;
        .rightContent2{
          width: 100%;
          flex: 1;
          background: rgba(0,0,0,.5);
          border: 1px solid #002D20;
          border-top: 0;
        }
      }
      .rightBox3{
        height: 280px;
        .rightContent3{
          width: 100%;
          flex: 1;
          background: rgba(0,0,0,.5);
          border: 1px solid #002D20;
          border-top: 0;
          display: flex;
          .rightContent3Left{
            width: 60%;
            height: 100%;
          }
          .rightContent3Right{
            height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            .rightContent3RightItem{
              width: 60%;
              padding: 0 5px;
              display: flex;
              justify-content: space-between;
              border-bottom:1px dashed rgba(255,255,255,.5);
              position: relative;
              .rightContent3RightItemName{
                color: rgba(255,255,255,.8);
                font-size: 14px;
                line-height: 32px;
                padding-left: 15px;
              }
              .rightContent3RightItemName::before{
                content:"";
                position: absolute;
                left: 0;
                top: 10px;
                width: 10px;
                height: 10px;
                border-radius: 50%;
                border: 2px solid #00FFBA;
              }
              .rightContent3RightItemValue{
                color: #00FFBA;
                font-size: 16px;
                line-height: 32px;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
    
  }
}
@keyframes line{
  0%{                     
      width: 0;
  } 
  /* to表示动画的结束位置，也可以使用100%来表示。 */
  50%{
    width: 96%;
  }
   100%{
     width: 0;
  }
} 
@keyframes bianda {
  0%{                     
       filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  } 
  50%{
     filter: drop-shadow(0 0 5px rgba(35, 151, 157, 1));
  }
   100%{
     filter: drop-shadow(0 0 0 rgba(35, 151, 157, 1));
  }
}
@keyframes daxiao {
  0%{                     
       transform: scale(0.96);
       text-shadow: 0 0 10px #fff;
  } 
  50%{
    transform: scale(1);
  }
   100%{
    transform: scale(0.96);
  }
}
@keyframes daxiao1 {
  0%{                     
      
       
  } 
  50%{
    text-shadow: 0 0 10px #fff;
  }
   100%{
    
  }
}
 @keyframes scale{
    0%{transform:scale(1)}
    50%,75%{transform:scale(3)}
    78%,100%{opacity:0}
}


@keyframes rightDaxiao {    /*引用动画名称*/
  0%{                     
       box-shadow: 0 0 10px 0px rgba(38,225,173,.8);
  } 
  50%{
    box-shadow: 0 0 10px 0px rgba(38,225,173,0);
  }
   100%{
    box-shadow: 0 0 10px 0px rgba(38,225,173,.8);
  }
}
@keyframes rightDaxiao1 {    /*引用动画名称*/
  0%{                     
       transform: scale(0.96);
  } 
  50%{
    transform: scale(1.2);
  }
   100%{
    transform: scale(0.96);
  }
}
@keyframes rightDaxiao2 {    /*引用动画名称*/
  0%{                     
       left:0
  } 
  50%{
    left: 50%;
  }
   100%{
    left: 100%;
  }
}

</style>
